import React from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { AccountControlRoutes } from "../../AccountControlsScreen";
import "./AccountControlsMenu.scss";

/**
 * AccountControlsMenu displays navigation links for account control features
 * including loss limits and self exclusion settings.
 */
const AccountControlsMenu: React.FC = () => {
  return (
    <nav className="account-controls-menu">
      <ul className="account-controls-menu__list">
        <li>
          <Link
            to={AccountControlRoutes.LossLimits}
            className="account-controls-menu__item"
          >
            <FormattedMessage id="loss-limits-title" />
          </Link>
        </li>

        <li>
          <Link
            to={AccountControlRoutes.SelfExclusion}
            className="account-controls-menu__item"
          >
            <FormattedMessage id="settings-self-exclusion" />
          </Link>
        </li>
      </ul>
    </nav>
  );
};

export default AccountControlsMenu;
